import { Stack, Typography, CircularProgress } from "@mui/material";

export const LoadingMessage = ({ message = "Loading! Please Wait..." , ...others}) => {
  return (
    <Stack
      alignItems="center"
      direction="row"
      justifyContent="center"
      spacing={2}
      {...others}
    >
      <CircularProgress size={20} color="secondary" />
      <Typography variant="subtitle2" color="primary">
        {message}
      </Typography>
    </Stack>
  );
};

export default LoadingMessage;
